import { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Box,
  Button,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  SvgIcon,
  InputAdornment,
  CardContent,
} from "@mui/material";
import { Search as SearchIcon } from "react-feather";

import {
  Checkbox,
  ListItemText,
  Input,
  Card,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Radio,
  Alert,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";
import StoresDropDown from "../General/StoresDropDown";
import qs from "qs";
import { useDispatch, useSelector } from "react-redux";
import {
  setSubmitted,
  selectedProducts,
  districtEnable,
  provinceEnable,
} from "redux/productParams";
import {
  disable,
  reset,
  setAllSelected,
  setItems,
  setAllItems,
  setPerStore,
} from "redux/dropDownStores";
import {
  setItemsList,
  resetItemsList,
  reloadItemsList,
  addMultipleSelect,
} from "redux/dropDownStores";
import { resetChartData } from "redux/productParams";
const theme = createTheme();

const useStyle = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(2),
    minWidth: 160,
    maxWidth: 800,
  },
  DatePicker: {
    width: "80%",
    minWidth: 50,
    marginRight: "auto",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    minWidth: 350,
  },
  selectList: {
    marginTop: theme.spacing(2),
    minWidth: 150,
  },

  search: {
    marginTop: theme.spacing(2),
    color: "red",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

export default function ProductsSearchForm({ sendDataToParent }) {
  const [products, setProducts] = useState([]);
  const [productselected, setProductselected] = useState([]);
  const [storeselected, setItemselected] = useState([]);
  const [districtEnabled, setDistrictEnabled] = useState(false);
  const [storeEnabled, setStoreEnabled] = useState(false);
  const [provinceEnabled, setProvinceEnabled] = useState(false);
  const [district, setDistrict] = useState("");
  const [province, setProvince] = useState("");
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [productFound, setProductFound] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [salesOption, setSalesOption] = useState("All");

  const dispatcher = useDispatch();
  const classes = useStyle();
  const params = useSelector((state) => state.productSales);

  const districts = [1, 2, 5, 22, 23, 24, 25, 26];
  const provinces = ["MB", "NB", "NL", "NS", "ON", "QC", "SK"];

  const allMultipleSelects = useSelector((state) => state.stores);
  const component =
    allMultipleSelects.findIndex(
      (el) => el.componentName === "products.stores",
    ) == -1
      ? 0
      : allMultipleSelects.findIndex(
          (el) => el.componentName === "products.stores",
        );

  const districtsComponent =
    allMultipleSelects.findIndex(
      (el) => el.componentName === "products.districts",
    ) == -1
      ? 0
      : allMultipleSelects.findIndex(
          (el) => el.componentName === "products.districts",
        );

  const provincesComponent =
    allMultipleSelects.findIndex(
      (el) => el.componentName === "products.provinces",
    ) == -1
      ? 0
      : allMultipleSelects.findIndex(
          (el) => el.componentName === "products.provinces",
        );
  const IfMounted = () => {
    const isMountRef = useRef(true);
    useEffect(() => {
      isMountRef.current = false;
    }, []);
    return isMountRef.current;
  };

  const didMounted = IfMounted();

  useEffect(() => {
    dispatcher(addMultipleSelect({ componentName: "products.stores" }));
    dispatcher(addMultipleSelect({ componentName: "products.districts" }));
    dispatcher(addMultipleSelect({ componentName: "products.provinces" }));
    dispatcher(setItems({ componentName: "products.stores", Items: ["All"] }));
    dispatcher(
      disable({ componentName: "products.districts", disabled: true }),
    );
    dispatcher(
      disable({ componentName: "products.provinces", disabled: true }),
    );
    dispatcher(
      setAllSelected({
        componentName: "products.stores",
        allItemsSelected: true,
      }),
    );
    dispatcher(disable({ componentName: "products.stores", disabled: true }));
    axios
      .get("/api/storesDetail", {
        params: {
          storeNumber: true,
        },
      })
      .then((res) => {
        dispatcher(
          setAllItems({
            componentName: "products.stores",
            allItems: res.data.nameNumber,
          }),
        );
      });
  }, []);

  useEffect(() => {
    if (allMultipleSelects[component].reloadItemsList) {
      axios
        .get("/api/storesDetail", {
          params: {
            storeNumber: true,
          },
        })
        .then((res) => {
          dispatcher(
            setItemsList({
              componentName: "products.stores",
              ItemsList: res.data.nameNumber,
            }),
          );
          dispatcher(
            setAllItems({
              componentName: "products.stores",
              allItems: res.data.nameNumber,
            }),
          );
        });
      dispatcher(reloadItemsList({ componentName: "products.stores" }));
    }
  }, [allMultipleSelects[component].reloadItemsList]);

  useEffect(() => {
    if (!didMounted && !allMultipleSelects[districtsComponent].disabled) {
      dispatcher(resetChartData());
      dispatcher(reset({ componentName: "products.stores" }));
      dispatcher(
        setAllSelected({
          componentName: "products.stores",
          allItemsSelected: false,
        }),
      );
      dispatcher(
        setAllSelected({
          componentName: "products.districts",
          allItemsSelected: false,
        }),
      );
      const loadData = async () => {
        const result = await axios.get("/api/districtStoresDetail", {
          params: {
            districtId: allMultipleSelects[districtsComponent].items,
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        dispatcher(
          setItemsList({
            componentName: "products.stores",
            ItemsList: result.data,
          }),
        );
      };
      loadData();
    }
  }, [allMultipleSelects[districtsComponent].items]);

  useEffect(() => {
    if (!didMounted && !allMultipleSelects[provincesComponent].disabled) {
      dispatcher(reset({ componentName: "products.stores" }));
      dispatcher(
        setAllSelected({
          componentName: "products.stores",
          allItemsSelected: false,
        }),
      );
      dispatcher(
        setAllSelected({
          componentName: "products.districts",
          allItemsSelected: false,
        }),
      );
      dispatcher(
        setAllSelected({
          componentName: "products.provinces",
          allItemsSelected: false,
        }),
      );
      dispatcher(resetChartData());
      const loadData = async () => {
        const result = await axios.get("/api/provinceStoresDetail", {
          params: {
            provinceId: allMultipleSelects[provincesComponent].items,
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        dispatcher(
          setItemsList({
            componentName: "products.stores",
            ItemsList: result.data,
          }),
        );
      };
      loadData();
    }
  }, [allMultipleSelects[provincesComponent].items]);

  useEffect(
    () => {
      if (
        (((!allMultipleSelects[districtsComponent].disabled ||
          salesOption == "Store" ||
          !allMultipleSelects[provincesComponent].disabled) &&
          allMultipleSelects[component].items.length > 0) ||
          salesOption == "All" ||
          salesOption == "All Per-Store") &&
        params.products.length > 0
      ) {
        setSubmitEnabled(true);
      } else {
        setSubmitEnabled(false);
      }
    },
    [allMultipleSelects[component].items],
    salesOption,
  );

  useEffect(() => {
    if (params.products.length > 0) {
      setSubmitEnabled(true);
    } else {
      setSubmitEnabled(false);
    }
  }, [params.products]);

  useEffect(() => {
    axios.get("/api/productsDetail").then((res) => {
      setProducts(res.data);
    });
  }, []);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleProductChange = (event) => {
    setProductselected(event.target.value);
    const value = event.target.value;
    dispatcher(
      selectedProducts(
        value.map((item) => item.substring(0, item.indexOf(" "))),
      ),
    );
    setSubmitEnabled(true);
  };

  const handleProvince = (event) => {
    setProvince(event.target.value);
  };

  function handleSubmit(event) {
    event.preventDefault();
    dispatcher(setSubmitted(true));
    sendDataToParent(startDate, endDate);
  }

  const [product, setProduct] = useState("");
  const handleRadio = (event) => {
    setSalesOption(event.target.value);
    dispatcher(resetChartData());
    dispatcher(reset({ componentName: "products.stores" }));
    dispatcher(reset({ componentName: "products.districts" }));
    dispatcher(reset({ componentName: "products.provinces" }));
    dispatcher(
      setAllSelected({
        componentName: "products.stores",
        allItemsSelected: false,
      }),
    );
    if (event.target.value == "Province") {
      dispatcher(
        disable({ componentName: "products.provinces", disabled: false }),
      );
      dispatcher(
        setAllSelected({
          componentName: "products.stores",
          allItemsSelected: false,
        }),
      );
      dispatcher(
        disable({ componentName: "products.stores", disabled: false }),
      );
      dispatcher(
        setItemsList({
          componentName: "products.provinces",
          ItemsList: provinces,
        }),
      );
      dispatcher(
        setAllSelected({
          componentName: "products.provinces",
          allItemsSelected: false,
        }),
      );
    }
    if (event.target.value == "District") {
      dispatcher(
        disable({ componentName: "products.districts", disabled: false }),
      );
      dispatcher(
        setAllSelected({
          componentName: "products.stores",
          allItemsSelected: false,
        }),
      );
      dispatcher(
        disable({ componentName: "products.stores", disabled: false }),
      );
      dispatcher(
        setItemsList({
          componentName: "products.districts",
          ItemsList: districts,
        }),
      );
      dispatcher(
        setAllSelected({
          componentName: "products.districts",
          allItemsSelected: false,
        }),
      );
    }
    if (event.target.value == "Store") {
      dispatcher(
        reloadItemsList({
          componentName: "products.stores",
          reloadItemsList: true,
        }),
      );
      dispatcher(provinceEnable(false));
      dispatcher(districtEnable(false));
      dispatcher(
        setAllSelected({
          componentName: "products.stores",
          allItemsSelected: false,
        }),
      );
      dispatcher(
        disable({ componentName: "products.stores", disabled: false }),
      );
      dispatcher(
        disable({ componentName: "products.districts", disabled: true }),
      );
    }
    if (event.target.value == "All") {
      dispatcher(
        setItems({ componentName: "products.stores", Items: ["All"] }),
      );
      dispatcher(
        setAllSelected({
          componentName: "products.stores",
          allItemsSelected: true,
        }),
      );
      dispatcher(disable({ componentName: "products.stores", disabled: true }));
      dispatcher(
        disable({ componentName: "products.districts", disabled: true }),
      );
      dispatcher(
        disable({ componentName: "products.provinces", disabled: true }),
      );
    }
    if (event.target.value == "All Per-Store") {
      dispatcher(
        setItems({ componentName: "products.stores", Items: ["All"] }),
      );
      dispatcher(
        setPerStore({ componentName: "products.stores", perStore: true }),
      );
      dispatcher(disable({ componentName: "products.stores", disabled: true }));
      dispatcher(
        disable({ componentName: "products.districts", disabled: true }),
      );
      dispatcher(
        disable({ componentName: "products.provinces", disabled: true }),
      );
    }
  };

  const handleInputChange = (event) => {
    setProduct(event.target.value);
  };

  const handleProductSearch = (event) => {
    setProduct(event.target.value);
    axios
      .get("/api/productSearch/", {
        params: {
          product: product,
        },
      })
      .then((res) => {
        const result = res.data;
        if (result.length) {
          const newList = productFound.filter(
            (current) => current.product_id !== result[0].product_id,
          );
          setProductFound(newList.concat(result));
          setErrorMessage("");
          setProduct("");
        } else {
          setProduct("");
          setErrorMessage("Product not found");
        }
      });
  };
  console.log(productFound);
  return (
    <form noValidate onSubmit={handleSubmit}>
      <Box ml={3} mr={3}>
        <Card>
          <CardContent>
            <Box pt={3} pb={3} ml={2}>
              <Grid container xs={12} md={12} spacing={1}>
                <Grid item md={3} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      disableToolbar
                      variant="inline"
                      inputVariant="outlined"
                      label="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                    ></DatePicker>
                  </LocalizationProvider>
                </Grid>
                <Grid item md={3} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      disableToolbar
                      variant="inline"
                      inputVariant="outlined"
                      label="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                    ></DatePicker>
                  </LocalizationProvider>
                </Grid>
                <Grid item md={6} xs={6}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Product Sales by:</FormLabel>
                    <RadioGroup
                      row
                      aria-label="searchOption"
                      name="searchOption"
                      value={salesOption}
                      onChange={handleRadio}
                    >
                      <FormControlLabel
                        value="All"
                        control={<Radio />}
                        label="All"
                      />
                      <FormControlLabel
                        value="All Per-Store"
                        control={<Radio />}
                        label="All Per-Store"
                      />
                      <FormControlLabel
                        value="Store"
                        control={<Radio />}
                        label="Store"
                      />
                      <FormControlLabel
                        value="District"
                        control={<Radio />}
                        label="District"
                      />
                      <FormControlLabel
                        value="Province"
                        control={<Radio />}
                        label="Province"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item md={12} xs={12}>
                  <Box pt={3} ml={-8}>
                    <StoresDropDown
                      componentName={"products.stores"}
                      width={400}
                      componentType={"stores"}
                    />
                  </Box>
                </Grid>

                <Grid item md={3} xs={3}>
                  <Box pt={3}>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SvgIcon fontSize="small" color="action">
                              <SearchIcon />
                            </SvgIcon>
                          </InputAdornment>
                        ),
                      }}
                      fullWidth={true}
                      placeholder="Search product"
                      variant="outlined"
                      value={product}
                      onChange={handleInputChange}
                    />
                  </Box>
                </Grid>
                <Grid item md={2} xs={2}>
                  <Box pt={5} ml={15}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleProductSearch}
                    >
                      Search
                    </Button>
                  </Box>
                </Grid>
                <Grid item md={2} xs={2}>
                  <Box pt={4}>
                    {errorMessage && (
                      <Alert severity="warning"> Product not found. </Alert>
                    )}
                  </Box>
                </Grid>

                <Grid item md={12} xs={12}>
                  <Box pt={5}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="products-mutiple-checkbox-label">
                        Products
                      </InputLabel>
                      <Select
                        labelId="products-mutiple-checkbox-label"
                        id="products-mutiple-checkbox"
                        sx={{
                          marginTop: 4,
                          marginBottom: 4,
                          width: 400,
                        }}
                        multiple
                        fullWidth
                        value={productselected}
                        onChange={(event) => handleProductChange(event)}
                        input={<Input />}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                      >
                        {productFound.map((item) => (
                          <MenuItem
                            key={item.product_id}
                            value={item.product_id + " " + item.product_name}
                          >
                            <Checkbox
                              checked={
                                productselected.indexOf(
                                  item.product_id + " " + item.product_name,
                                ) > -1
                              }
                            />
                            <ListItemText
                              primary={
                                item.product_id + " " + item.product_name
                              }
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item md={2} xs={6}>
                  <Box pt={3} pr={3} ml={-8}>
                    <StoresDropDown
                      componentName={"products.districts"}
                      width={150}
                      componentType={"districts"}
                    />
                  </Box>
                </Grid>
                <Grid item md={2} xs={6}>
                  <Box pt={3} ml={-8}>
                    <StoresDropDown
                      componentName={"products.provinces"}
                      width={150}
                      componentType={"provinces"}
                    />
                  </Box>
                </Grid>
                <Box pt={3}>
                  <Grid item md={2} xs={6} style={{ marginTop: 22, ml: 35 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={!submitEnabled}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Box>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </form>
  );
}
